import { parse as parseCsvString } from 'csv-string';
import { pipe } from 'ramda';

const defaultIndex = index => (index < 0 ? 0 : index);

const findColumnIndex = name => array =>
  array.findIndex(column => column.toLowerCase().includes(name));

const getRows = table => {
  const rows = table.split('\n');
  if (rows.length < 2) return [];
  return rows.slice(1);
};

export const filterTable = (table, model) => {
  if (table == null || model == null) return '';
  const row = getRows(table).filter(r =>
    r.toLowerCase().includes(model.toLowerCase())
  );
  return `${getHeaderRow(table)}\n${row}`;
};

export const getHeaderRow = table => table.split('\n')[0];

export const getIndex = index => array => array[index];

export const getModels = table => {
  const modelColumn = getModelsColumnIndex(table);
  return parseCsvString(table)
    .filter((_, i) => i > 0)
    .map(row => row[modelColumn]);
};

export const getModelsColumnIndex = pipe(
  parseCsvString,
  getIndex(0),
  findColumnIndex('model'),
  defaultIndex
);
